import { render, staticRenderFns } from "./ComponentManager.vue?vue&type=template&id=24775068&"
import script from "./ComponentManager.vue?vue&type=script&lang=js&"
export * from "./ComponentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports